import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@/styles/sass/style.scss';
import { en, ko } from 'vuetify/es5/locale';

Vue.use(Vuetify);

export default new Vuetify({
  // 언어 설정
  lang: {
    locales: { ko, en },
    //current: 'ko', // (22.6.10) 한글달력 포맷문제로 주석처리, datePicker.js로 사용
  },
  theme: {
    dark: false, // dark theme 제외
    default: 'light',
    themes: {
      // light 모드 적용시 스타일 지정
      light: {
        primary: '#363c43',
        black: '#363c43',
        realBlack: '#000',
        blue: '#087ef7',
        darkGrey: '#465166',
        deepGrey: '#465166',
        grey: '#777e87',
        lightGrey: '#f4f5f5',
        lightBlueGrey: '#f2f4f6',
        red: '#ff5c5c',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#EF4242',
        info: '#2196F3',
        success: '#1CC966',
        warning: '#FB8C00',
        inputBG: '#fcfcfc',
        selectedBlue: '#1251fc',
        selectedGray: '#f4f5f5',
        white: '#fff',
      },
      // dark 모드 적용시 스타일 지정
      // 이 프로젝트에서 사용 안함
      // dark: {
      //   primary: '#2196F3',
      //   secondary: '#424242',
      //   accent: '#FF4081',
      //   error: '#FF5252',
      //   info: '#2196F3',
      //   success: '#4CAF50',
      //   warning: '#FB8C00',
      // },
    },
    icons: {
      values: {
        custom: {
          // name of our custom icon
        },
      },
    },
  },
});
